import { ExperimentsModel } from 'client/data/models/experiments';
import { VisitorModel } from 'client/data/models/visitor';
import { PageModel } from 'client/data/models/page';

export async function getExperimentState(context) {
  const [computed, published, { dma }, vehicle] = await Promise.all([
    context.resolveValue('computed', ExperimentsModel),
    context.resolveValue('published', ExperimentsModel),
    context.resolveValue('location', VisitorModel),
    context.resolveValue('vehicle', PageModel),
  ]);

  return {
    experiments: {
      computed,
      published,
    },
    visitor: { location: { dma } },
    pageContext: { vehicle },
  };
}
